module.exports = __webpack_public_path__ + "static/media/battery.dc282d44.svg";